import React, { useState, useEffect } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import "./DashboardSideBar/DashboardSideBar.css";
import axios from "axios";
import Cookies from "js-cookie";
import EvnVar from "../EnvVar";
import { useAuth } from "../AuthContext";

function AuthLayout() {
  // const navigate = useNavigate();

  const baseURL = EvnVar();
  const { setIsAuthenticated } = useAuth(); // Get setIsAuthenticated from context
  const token = Cookies.get("jwt");
  const usermenues = {
    "Ambassador Dashboard": "/ambassador/dash",
    "Upload Events": "/ambassador/events",
    "Social Media": "/ambassador/social-media",
    "Financial Literate Individual": "/ambassador/educate-individual",
    Testimonials: "/ambassador/testimonials",
    "FTL Activities": "/ambassador/other-activities",
    Profile: "/ambassador/edit-profile",
    "View SOP": "/ambassador/view-sop",
  };
  // console.log("usermenues", usermenues);
  const adminmenues = {
    "Admin Dashboard": "/ambassador/admin-dash",
    Slogan: "/ambassador/admin-slogan",
    "FTL Activities": "/ambassador/admin-other-activities",
    Events: "/ambassador/admin-events",
    Evaluation: "/ambassador/admin-evaluation",
    Allocation: "/ambassador/admin-allocation",
    "Lead Ambassador Selection": "/ambassador/best-ambassador-selection",
    "Lead Ambassador": "/ambassador/best-ambassador",
    "Ambassadors Report": "/ambassador/ambassadors-report",
    "VGM Report": "/ambassador/vgm-report",
    "Upload CSV": "/ambassador/uploading-file",
    "Add Event Program": "/ambassador/event-program",
  };

  // const [profile, setProfile] = useState(false);
  // const toggleProfile = () => {
  //     setProfile(!profile);
  // };

  const [sidebar, setSidebar] = useState(true);
  const [loader, setLoader] = useState(false);
  const toggleSidebar = () => {
    setSidebar(!sidebar);
  };

  // console.log('Screen width', window.innerWidth);
  // console.log('Window width using usestate', width);
  const [width, setWidth] = useState(window.innerWidth);

  const closeNavbar = () => {
    if (width <= 992) {
      setSidebar(false);
    }
  };

  const [role, setRole] = useState();

  // Update width on window resize
  useEffect(() => {
    setIsAuthenticated(false);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseURL}/auth/isLoggedin`,
      headers: {
        Authorization: token,
      },
      withCredentials: true,
    };

    axios
      .request(config)
      .then((response) => {
        let result = JSON.stringify(response.data);
        let data = JSON.parse(result);
        // console.log("Is Admin =>", data.role);
        setRole(data.role);
      })
      .catch((error) => {
        console.log("Error fetching data:", error);
      });

    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleLogout = () => {
    setLoader(true);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseURL}/dash/logout`,
      headers: {
        "content-type": "application/json",
        Authorization: token,
      },
      withCredentials: true,
    };

    axios
      .request(config)
      .then((response) => {
        const responseData = JSON.stringify(response.data);
        // console.log("DataResponse:", responseData);
        removeCookie("jwt");
        // window.location.reload();
        setIsAuthenticated(true);
        setLoader(false);
        // removeCookie('laravel_session');
        // navigate('ambassador/login');
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };

  function removeCookie(name) {
    document.cookie =
      name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  return (
    <div className="dashboard-sidebar">
      <div className="d-flex">
        {sidebar && (
          <div className="sidebar">
            <div className="nav-bar">
              <Link to="/ambassador/" className="logo">
                <img
                  className="img-fluid"
                  src="https://vitiyagyanmela.icai.org/images/upload/660d6c0ea1f98.jpg"
                />
              </Link>
              {["admin", "branch", "CCM", "RCM"].includes(role) ? (
                <ul className="ps-0 mb-0 main-nav">
                  {Object.keys(adminmenues).map((key) => {
                    return (
                      <li key={key}>
                        <NavLink
                          onClick={closeNavbar}
                          to={adminmenues[key]}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          {" "}
                          {key}
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <ul className="ps-0 mb-0 main-nav">
                  {Object.keys(usermenues).map((key) => {
                    return (
                      <li key={key}>
                        <NavLink
                          onClick={closeNavbar}
                          to={usermenues[key]}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          {" "}
                          {key}
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
        )}
        <div className={`sidebar-right ${!sidebar ? "w-100" : ""}`}>
          <nav className="d-flex py-4 px-4 justify-content-between align-items-center navbar-dashboard">
            <i className="fas fa-bars" onClick={toggleSidebar}></i>
            {loader && loader ? (
              <button type="button" className="btn btn-warning" disabled>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>{" "}
                Logout
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-warning"
                onClick={handleLogout}
              >
                Logout
              </button>
            )}
          </nav>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
